import React from 'react';
import { AboutBadge } from '../AboutBadge';
import aboutListPoint from './about-list-point.png';

export function SectionAbout() {
  return (
    <section className="bg-white rounded-3xl sm:rounded-[48px] p-4 sm:p-6 md:p-10 mt-[-24px] mx-2 sm:mx-4 relative z-[1]">
      <div className="px-0 sm:px-8 md:px-16 lg:px-[100px]">
        <AboutBadge text="Что такое SMRhub?" />
        <h4 className="font-bold text-xl sm:text-2xl md:text-[32px] leading-tight sm:leading-[58px] my-3 sm:my-4">
          SMRhub – это удобная платформа, где:
        </h4>
        <ul className="list-none m-0 p-0">
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${aboutListPoint})` }}
            />
            Управление процессами становится более структурированным и
            прозрачным;
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${aboutListPoint})` }}
            />
            Легко создавать, редактировать и отслеживать заявки;
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${aboutListPoint})` }}
            />
            Пошаговая инструкция по использованию платформы представлена в
            четырех видеороликах:
          </li>
        </ul>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-9 pt-6 sm:pt-8">
          {[0, 1, 2, 3].map((itemIndex) => (
            <div
              key={itemIndex}
              className="relative h-40 sm:h-40 rounded-2xl sm:rounded-[20px] overflow-hidden"
            >
              <iframe
                src="https://www.youtube.com/embed/W5AEFEkOhpA"
                title="THIS or a Land Cruiser? 2024 Lexus GX550 Review"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
